import { Component, effect, input, OnInit, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

import { Location } from '@era/locations-sdk';

@Component({
  selector: 'era-location-select-ui',
  templateUrl: './location-select.component.html',
  imports: [ReactiveFormsModule],
})
export class LocationSelectComponent implements OnInit {
  readonly isEnabled = input.required<boolean>();
  readonly locations = input.required<Location[]>();
  readonly location = input.required<Location>();

  readonly locationChange = output<Location>();

  readonly selectLocation = new UntypedFormControl('');

  constructor() {
    effect(() => {
      const location = this.location();
      this.selectLocation.setValue(location);
    });
  }

  ngOnInit() {
    this.selectLocation.valueChanges.subscribe((location) => {
      if (location) {
        this.locationChange.emit(location);
      }
    });
  }
}
